export interface RequestParameters {
    overrideAccessToken?: string
}

export const getRequestConfig = (requestParameters: RequestParameters) => {
    if (!requestParameters || !requestParameters.overrideAccessToken) return {}

    return { headers: { Authorization: `Bearer ${requestParameters.overrideAccessToken}` } }
}
